import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { fetchAddresses, deleteAddress } from "../../store/feature/addressSlice";

const AddressList: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { addresses, loading, error } = useSelector((state: RootState) => state.address);
  const token = localStorage.getItem("token") || "";

  useEffect(() => {
    dispatch(fetchAddresses());
  }, [dispatch, token]);

  const handleDelete = (id: number) => {
    dispatch(deleteAddress({ token, id }));
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-2xl font-bold text-center mb-4">Adres Listesi</h1>
      {loading ? (
        <p className="text-center text-gray-500">Yükleniyor...</p>
      ) : error ? (
        <p className="text-center text-red-500">{error}</p>
      ) : (
        <div className="bg-white shadow-md rounded-lg overflow-hidden">
          <ul>
            {addresses.map((address) => (
              <li
                key={address.id}
                className="flex items-center justify-between p-4 border-b border-gray-200"
              >
                <span className="text-lg font-medium">{address.value}</span>
                <button
                  onClick={() => handleDelete(address.id)}
                  className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
                >
                  Sil
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AddressList;
